"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SVG = _interopRequireDefault(require("./SVG"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var XIcon = function XIcon(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style,
      viewBox = _ref.viewBox,
      fill = _ref.fill,
      className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_SVG.default, {
    style: style,
    width: width || '32',
    height: height || '32',
    viewBox: viewBox || '0 0 32 32',
    fill: fill,
    className: className,
    path: "M14.5859 16.0002L7.87883 9.29304C7.48831 8.90252 7.48831 8.26935 7.87883 7.87883C8.26935 7.48831 8.90252 7.48831 9.29304 7.87883L16.0002 14.5859L22.7073 7.87883C23.0978 7.48831 23.7309 7.48831 24.1215 7.87883C24.512 8.26936 24.512 8.90252 24.1215 9.29304L17.4144 16.0002L24.1215 22.7073C24.512 23.0978 24.512 23.7309 24.1215 24.1215C23.7309 24.512 23.0978 24.512 22.7073 24.1215L16.0002 17.4144L9.29304 24.1215C8.90252 24.512 8.26936 24.512 7.87883 24.1215C7.48831 23.7309 7.48831 23.0978 7.87883 22.7073L14.5859 16.0002Z"
  });
};

var _default = XIcon;
exports.default = _default;